import React, { useState } from 'react';

import './App.css';

function App() {
  const [rand, setRand] = useState<number | '-'>('-');
  const minVal = 1;
  const maxVal = 10;

  function randNum(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  function calculate() {
    setRand(randNum(minVal, maxVal));
  }

  return (
    <div className='App'>
      <div className="App-body">
        <div className='App-header'>Generate random value between {minVal} and {maxVal}</div>
        <div className='random-value'>{rand}</div>
        <div>
          <button className='my-button' onClick={calculate} autoFocus={true}>Generate!</button>
        </div>
      </div>
    </div>
  );
}

export default App;
